import script from "./DriverTreeView.vue?vue&type=script&setup=true&lang=js"
export * from "./DriverTreeView.vue?vue&type=script&setup=true&lang=js"

import "./DriverTreeView.vue?vue&type=style&index=0&id=c1e1e254&scoped=true&lang=css"

import exportComponent from "/home/runner/work/TIMS-APP/TIMS-APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1e1e254"]])

export default __exports__